import Papa from "papaparse";
import moment from "moment";

function checkHeaderFormat(array1, array2) {
  // Convert arrays to lowercase sets for case-insensitive comparison
  const set1 = new Set(array1);
  const set2 = new Set(array2);

  // Check if all strings from set1 are present in set2
  for (let string of set1) {
    if (!set2.has(string)) {
      return false; // Found a string that is not present in set2, return false
    }
  }

  return true; // All strings from set1 are present in set2
}

export function checkNull(item, keys) {
  const keysToCheck = keys.split(",");
  if (!Array.isArray(keysToCheck)) {
    throw new Error("keysToCheck must be an array");
  }

  return keysToCheck.some((key) => item[key] === null);
}

const CorrectFormatCar = {
  make: "",
  offerTitle: "",
  offerText_rephrased: "",
  modelsText: "",
  fromDate: "",
  toDate: "",
  linkText: "",
  linkAddress: "",
  state: "",
  offerType: "",
  image: "",
};

export function validateCSV(file) {
  return new Promise((resolve, reject) => {
    try {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        complete: (results) => {
          const { data, meta } = results;

          if (!checkHeaderFormat(Object.keys(CorrectFormatCar), meta.fields))
            return reject({
              message:
                "Please make sure these columns are present make, offerTitle, offerText_rephrased, modelsText, fromDate, toDate linkText, image, linkAddress. Column names are case sensitive",
              error: {},
            });

          let validDataCount = 0,
            invalidDataCount = 0;

          const validData = [];

          data.forEach((item) => {
            if (
              checkNull(
                item,
                "make,offerTitle,offerText_rephrased,modelsText,fromDate"
              ) ||
              !item.fromDate.includes("/") ||
              item.fromDate === null ||
              moment(item.fromDate, "DD/MM/YYYY").toISOString() === null
            ) {
              invalidDataCount += 1;

              // !item.fromDate.includes("/") ||
              // !item.toDate.includes("/") ||
              // item.fromDate === null ||
              // item.toDate === null
            } else {
              validDataCount += 1;
              if (item.make.includes("\n")) {
                item.make = item.make.replace("\n", "");
              }

              if (item.linkText === null) item.linkText = "";
              if (item.linkAddress === null) item.linkAddress = "";
              if (item.state === null) item.state = "";
              if (item.offerType === null) item.offerType = "all";
              if (item.image === null) item.image = "";
              // item.fromDate = moment(item.fromDate, "DD/MM/YYYY").toISOString();
              // item.toDate = moment(item.toDate, "DD/MM/YYYY").toISOString();
              validData.push(item);
            }
          });

          resolve({
            validDataCount,
            invalidDataCount,
            validData,
          });
        },
      });
    } catch (error) {
      reject({
        message: "File could not be parsed",
        error,
      });
    }
  });
}
